import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";

import * as orderActions from '../../_redux/orders/ordersActions';
import * as lineActions from '../../_redux/orderlines/orderlinesActions';
import {Card} from "react-bootstrap";
import {CardTable} from "./card-table/CardTable";
import {CardFinalizeOrderDialog} from "./card-finalize-order/CardFinalizeOrderDialog";
import {CardOnlinePaymentDialog} from "./card-online-payment/CardOnlinePaymentDialog";

export function CardPage() {


    const {lastOrder, user} = useSelector(
        (state) => ({
            lastOrder: state.orders.lastOrder,
            user: state.auth.user,
        })
    );

    const [showDialog, setShowDialog] = useState(false);
    const [showPayment, setShowPayment] = useState(false);


    const dispatch = useDispatch();

    const PaymentRequired = useMemo(() => {
        if (!lastOrder) return false;

        const orderedBranchId = lastOrder.branchId;
        const userBranch = user.branches.find(b => b.id === orderedBranchId);
        if (userBranch && userBranch.id === orderedBranchId) {
            return userBranch.onlinePaymentEnabled;
        }

        return false;
    }, [lastOrder, user])

    useEffect(() => {
        dispatch(orderActions.getOpenOrder());
    }, [dispatch, showDialog]);


    return (
        <>
            <CardFinalizeOrderDialog onHide={() => setShowDialog(false)}
                                     id={lastOrder && lastOrder.id}
                                     show={showDialog}/>
            <CardOnlinePaymentDialog show={showPayment} onHide={() => setShowPayment(false)}
            />
            <Card className={"px-3 py-2"}>

                {lastOrder ? (
                    <>
                        <h1>اطلاعات {lastOrder.name}</h1>
                        <CardTable setShowDialog={setShowDialog}/>
                        <div>
                            <button type={"button"}
                                    onClick={() => {
                                        PaymentRequired ? setShowPayment(true) : setShowDialog(true);
                                    }}
                                    className={"btn btn-primary"}>
                                {PaymentRequired ? (
                                    <>
                                        پرداخت آنلاین
                                    </>
                                ) : (
                                    <>
                                        ثبت نهایی سفارش
                                    </>
                                )
                                }
                            </button>
                        </div>
                    </>
                ) : (
                    <h1>شما هیچ سفارش بازی ندارید.</h1>
                )}
            </Card>
        </>
    )
}